// Validation utilities for signup process
import { GDC_REQUIRED_ROLES, JOB_ROLES_LIST } from './constants';

// Age requirements by role (minimum age in years)
export const AGE_REQUIREMENTS = {
  'Nurse': 18,
  'Hygienist': 18,
  'Dentist': 18,
  'Therapist': 18,
  'Receptionist': 16
};

// Calculate age from date of birth
export const calculateAge = (dateOfBirth) => {
  if (!dateOfBirth) return null;
  
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  
  return age;
};

// Validate age for role
export const validateAgeForRole = (dateOfBirth, jobRole) => {
  if (!dateOfBirth) {
    return { isValid: false, error: 'Date of birth is required' };
  }
  
  const age = calculateAge(dateOfBirth);
  if (age === null) {
    return { isValid: false, error: 'Invalid date of birth' };
  }
  
  const minimumAge = AGE_REQUIREMENTS[jobRole];
  if (!minimumAge) {
    return { isValid: true, error: null }; // No age requirement for unknown roles
  }
  
  if (age < minimumAge) {
    return {
      isValid: false,
      error: `You must be at least ${minimumAge} years old to register as a ${jobRole}. You are currently ${age} years old.`
    };
  }
  
  return { isValid: true, error: null };
};

// Check if GDC is required for role
export const isGdcRequiredForRole = (jobRole) => {
  return GDC_REQUIRED_ROLES.includes(jobRole);
};

// Validate GDC number format
export const validateGdcNumber = (gdcNumber, jobRole) => {
  if (isGdcRequiredForRole(jobRole)) {
    if (!gdcNumber || !gdcNumber.trim()) {
      return {
        isValid: false,
        error: 'GDC registration number is required for your role. All dental professionals must be registered with the General Dental Council (GDC) to practice legally in the UK.'
      };
    }
    
    const trimmedGdc = gdcNumber.trim();
    if (!/^\d{5,6}$/.test(trimmedGdc)) {
      return {
        isValid: false,
        error: 'GDC number must be 5 or 6 digits. Please check your registration number from the GDC register.'
      };
    }
    
    return { isValid: true, error: null };
  }
  
  return { isValid: true, error: null };
};

// Validate job role
export const validateJobRole = (jobRole) => {
  if (!jobRole || !jobRole.trim()) {
    return {
      isValid: false,
      error: 'Please select your job role to continue'
    };
  }
  
  if (!JOB_ROLES_LIST.includes(jobRole)) {
    return {
      isValid: false,
      error: 'Invalid job role selected'
    };
  }
  
  return { isValid: true, error: null };
};

